type EnergyMarkKey =
  | 'A2020'
  | 'A2015'
  | 'A2010'
  | 'A'
  | 'B'
  | 'C'
  | 'D'
  | 'E'
  | 'F'
  | 'G'
  | '?';

interface EnergyMarkProps {
  mark: EnergyMarkKey | string;
}

const EnergyMark = ({ mark }: EnergyMarkProps) => {
  const colors: Record<EnergyMarkKey, string> = {
    A2020: '#3a9c2d', // Green
    A2015: '#51ad45', // Green
    A2010: '#6EC064', // Green
    A: '#6EC064', // Green
    B: '#B5C334', // Light Green
    C: '#F7B731', // Yellow
    D: '#F39C12', // Orange
    E: '#E74C3C', // Red
    F: '#C0392B', // Dark Red,
    G: '#C0392B',
    '?': '#7F8C8D', // Gray
  };

  const color = colors[mark as EnergyMarkKey] ?? '#7F8C8D'; // Default to gray if mark is invalid
  if (!mark) return null;
  return (
    <>
      <div
        style={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '10px',
            fontSize: '14px',
            fontWeight: 'bold',
            color: '#ffffff',
            height: '20px',
            textAlign: 'center',
            backgroundColor: color,
          }}
        >
          <span style={{ fontSize: '16px' }}>{mark}</span>
        </div>
        <div
          style={{
            width: 0,
            height: 0,
            borderLeft: '10px solid',
            borderRight: '10px solid transparent',
            borderBottom: '10px solid transparent',
            borderTop: '10px solid transparent',
            borderLeftColor: color,
          }}
        />
      </div>
    </>
  );
};

export default EnergyMark;
